import { render } from "./FoodWhatToDoSection.vue?vue&type=template&id=254a6dcf&scoped=true"
import script from "./FoodWhatToDoSection.vue?vue&type=script&lang=js"
export * from "./FoodWhatToDoSection.vue?vue&type=script&lang=js"

import "./FoodWhatToDoSection.vue?vue&type=style&index=0&id=254a6dcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254a6dcf"]])

export default __exports__